import React from 'react';
import { Modal as AntModal } from 'antd';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { resetAlert } from '@redux/game/gameSlice';
import { IMG_MAINTAIN } from '@assets';
import { useTranslation } from 'react-i18next';

const Modal = styled(AntModal)`

.ant-modal-title {
    text-align: center;
    color: #90348a;
    text-transform: capitalize;
}

.ant-modal-content {
    text-align: center;
    padding: 30px 24px;
}

.ant-modal-footer {
    text-align: center;
    padding-top: 12px;

    .ant-btn-default {
        display: none !important;
    }

    .ant-btn {
        min-width: 100px;
    }
}
`;

const Image = styled.img.attrs({
    alt: 'img',
    src: IMG_MAINTAIN,
})`
margin: 12px 0;
`;

const GameAlert = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { maintain, open, title, description } = useSelector(state => state.game.alert);

    const handleClose = () => {
        dispatch(resetAlert());
    }

    return (
        <Modal
            centered
            destroyOnClose
            closable={false}
            width={300}
            title={title}
            open={open}
            onCancel={handleClose}
            onOk={handleClose}
            okText={t("common.ok")}
        >
            {maintain && <Image />}
            <div>{description}</div>
        </Modal>
    );
}

export default GameAlert;